import { render, staticRenderFns } from "./ObjectExtras.vue?vue&type=template&id=4ef67bac&scoped=true&"
import script from "./ObjectExtras.vue?vue&type=script&lang=js&"
export * from "./ObjectExtras.vue?vue&type=script&lang=js&"
import style0 from "./ObjectExtras.vue?vue&type=style&index=0&id=4ef67bac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef67bac",
  null
  
)

export default component.exports